import { CheckboxButton } from "element-ui";
import FormBase from "./FormBase";
export default {
  name: "AceCheckboxButton",
  mixins: [CheckboxButton, FormBase],
  data() {
    return {
      isAuth: true,
    };
  },
  computed: {
    isDisabled() {
      return this._checkboxGroup
        ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled || !this._checkboxGroup.isAuth || !this.isAuth
        : this.disabled || (this.elForm || {}).disabled || !this.isAuth;
    },
  },
};
